import React from "react";
import { t } from "@lingui/macro";
import { i18n } from "@base/common/libs/i18n";

import { Tooltip, TOOLTIP_POSITION } from "widgets/feedback";
import { KfIcon, KF_ICONS, ICON_SIZE, ICON_STROKE } from "widgets/kficon";
import { handleCommunityRedirection } from "account/community";

import styles from "../styles.css";

export const Help = () => {
  return (
    <div className={styles.helpNav}>
      <Tooltip
        content={i18n._(t`Get help from the Kissflow Community`)}
        position={TOOLTIP_POSITION.BOTTOM}
      >
        <div
          className={styles.helpNavbutton}
          onClick={() => handleCommunityRedirection(true)}
        >
          <KfIcon
            icon={KF_ICONS.HELP}
            size={ICON_SIZE.SIZE_20}
            stroke={ICON_STROKE.REGULAR}
            className={styles.helpMenuIcon}
          />
        </div>
      </Tooltip>
    </div>
  );
};
